import React, { useEffect, useState } from "react";
import CustomTable from "../../../../components/Tables/CustomTable";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import {
  fetchUsersAsync,
  resetAdminState,
  setSelectedUser,
} from "../../../../redux/features/adminSlice";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import SearchInput from "../../../../components/form/SearchInput";
import Button from "../../../ui/Button";
import moment from "moment";
import DateRangeSelector, {
  DateRangeType,
} from "../../../ui/DateRangeSelector";
import { useNavigate } from "react-router-dom";

const VendorTable: React.FC = () => {
  const { vendors, isLoading } = useAppSelector((state) => state.admin);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedRange, setSelectedRange] = useState<DateRangeType>({
    startDate: null,
    endDate: null,
  });
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Name of Vendor", field: "vendor_name" },
    { label: "Username", field: "username" },
    { label: "Phone Number", field: "phone_number" },
    { label: "Email", field: "email" },
    { label: "Brand Name", field: "brandName" },
    { label: "Business Phone Number", field: "business_phone_number" },
    { label: "Business Email", field: "business_email" },
    { label: "Business City", field: "business_city" },
    { label: "Country", field: "country" },
    { label: "Reg. Date", field: "date_added" },
  ];

  const vendorData = vendors?.data?.data?.map((vendor: any, index: number) => {
    return {
      _vendor: vendor,
      id: index + 1,
      vendor_name: vendor?.fullName ?? "N/A",
      username: vendor?.username ?? "N/A",
      phone_number: vendor?.phoneNumber ?? "N/A",
      brand_name: vendor?.business?.name ?? "N/A",
      business_email: vendor?.business?.businessEmail ?? "N/A",
      business_phone_number: vendor?.business?.businessPhoneNumber ?? "N/A",
      business_city: vendor?.business?.businessCity ?? "N/A",
      country:
        (typeof vendor?.country === "string"
          ? vendor?.country
          : vendor?.country?.name) ?? "N/A",
      email: vendor?.email ?? "N/A",
      date_added: moment(vendor?.createdAt).format("MMM DD, YYYY"),
    };
  });

  useEffect(() => {
    dispatch(resetAdminState());
    dispatch(
      fetchUsersAsync({
        page: page + 1,
        limit,
        filter,
        userType: "VENDOR",
        startDate: selectedRange.startDate,
        endDate: selectedRange?.endDate,
      }),
    );
  }, [page, limit, filter, dispatch, selectedRange]);

  const tabList = [
    { id: 1, name: "All Vendors", count: vendors?.data?.totalItems ?? 0 },
  ];

  const handleDateChange = (range: DateRangeType) => {
    setSelectedRange(range);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setFilter(inputValue);
    }
  };

  return (
    <WhiteTitledCard>
      <div className="px-6">
        <div className="flex flex-col md:justify-between gap-4 mb-4">
          {/* Tabs List */}
          {/* Search and Filter */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2 w-full md:w-auto">
            <DateRangeSelector
              initialRange={selectedRange}
              onChange={handleDateChange}
            />
            <div className="flex gap-2">
              <SearchInput
                placeholder="Search"
                onChange={(e: any) => {
                  setInputValue(e.target.value);
                  setPage(0);
                }}
                value={inputValue}
                onKeyDown={handleKeyDown}
              />
              <Button
                customStyle={{
                  width: "auto",
                  height: "40px",
                }}
                label="Filter"
                onClick={() => setFilter(inputValue)}
                classNames="hidden sm:flex"
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row flex-wrap items-center gap-3">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className="space-x-2 cursor-pointer text-sm font-semibold p-2 text-black border-b-2 border-primary"
              >
                <span>{tab.name}</span>
                <span className="bg-lightPurple px-2 text-accent rounded-md">
                  {tab?.count}
                </span>
              </div>
            ))}
          </div>
        </div>

        <CustomTable
          data={{ columns, rows: vendorData }}
          onRowClick={(row) => {
            dispatch(setSelectedUser(row._vendor));
            navigate(`/user-management/vendor/${row._vendor?.id}`);
          }}
          noRecordText="No Vendor Users Available"
          loading={isLoading}
          showFooter={true}
          totalPages={vendors?.data?.totalPages}
          itemsPerPage={vendors?.data?.itemsPerPage}
          currentPage={page}
          onPageChange={(value: number) => setPage(value)}
          onLimitChange={(value: number) => {
            setLimit(value);
            setPage(0);
          }}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default VendorTable;
